import React from 'react';
import { Package, MapPin, DollarSign, Home, Truck, Calculator, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const PopularShippingServicesSection = () => {
  const services = [
    {
      title: 'Shipping to India',
      description: 'Affordable parcel shipping from Canada to India with trusted carriers',
      icon: Package,
      link: '/shipping-to-india-from-canada',
      color: 'from-red-600 to-yellow-500'
    },
    {
      title: 'Brampton Shipping',
      description: 'International shipping services from Brampton to worldwide destinations',
      icon: MapPin,
      link: '/international-shipping-brampton',
      color: 'from-red-600 to-yellow-500'
    },
    {
      title: 'Toronto Courier',
      description: 'Fast international courier services from Toronto and GTA',
      icon: Truck,
      link: '/international-courier-toronto',
      color: 'from-red-600 to-yellow-500'
    },
    {
      title: 'Shipping Cost',
      description: 'Compare courier rates and find the best shipping prices to India',
      icon: Calculator,
      link: '/shipping-cost-canada-to-india',
      color: 'from-red-600 to-yellow-500'
    },
    {
      title: 'Cheap Shipping',
      description: 'Budget-friendly rates for Canada to India shipping',
      icon: DollarSign,
      link: '/cheap-shipping-canada-to-india',
      color: 'from-red-600 to-yellow-500'
    },
    {
      title: 'Relocation Services',
      description: 'Complete household and relocation shipping to India',
      icon: Home,
      link: '/relocation-shipping-canada-to-india',
      color: 'from-red-600 to-yellow-500'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Popular Shipping Services</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Explore our specialized international shipping solutions tailored to your needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <a key={index} href={service.link} className="block group" data-aos="fade-up" data-aos-delay={300 + index * 100}>
                <Card className="h-full bg-gray-800 border-gray-700 hover:border-red-500 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
                  <CardContent className="pt-6">
                    <div className={`w-14 h-14 bg-gradient-to-r ${service.color} rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                      <IconComponent className="w-7 h-7 text-white" />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-3 group-hover:text-red-400 transition-colors">
                      {service.title}
                    </h3>
                    <p className="text-gray-300 leading-relaxed">
                      {service.description}
                    </p>
                    <div className="mt-4 text-red-400 font-semibold flex items-center gap-2 group-hover:gap-3 transition-all">
                      Learn More
                      <ArrowRight className="w-4 h-4" />
                    </div>
                  </CardContent>
                </Card>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PopularShippingServicesSection;
